import React from "react";

// Cele doua bannere (ca pe dentalelite.ro): ADR Sud-Vest Oltenia si "Proiecte Regio".
// Proiectul KFY e unul singur, deci ambele duc la aceeasi pagina de proiect.
// Cu "/" la final: pe cPanel/Apache pagina e folderul proiect-regio/, fara "/" ar face redirect.
const PAGINA_PROIECT = "/proiect-regio/";

const RegioBanners = () => (
  <section id="top" className="regio-banner">
    <div className="regio-banners">
      <a
        className="regio-card regio-card-adr"
        href={PAGINA_PROIECT}
        title="Proiect cofinanțat prin Programul Regional Sud-Vest Oltenia 2021-2027"
      >
        <picture>
          <source srcSet="/images/regio/adr-sud-vest-oltenia.webp" type="image/webp" />
          <img
            src="/images/regio/adr-sud-vest-oltenia.png"
            alt="ADR Sud-Vest Oltenia — Dolj, Gorj, Mehedinți, Olt, Vâlcea"
            width="508"
            height="160"
          />
        </picture>
      </a>

      <a
        className="regio-card regio-card-proiecte"
        href={PAGINA_PROIECT}
        title="Detalii proiect cofinanțat de Uniunea Europeană"
      >
        <span className="regio-card-text">
          <span className="regio-card-title">
            Proiecte <strong>Regio</strong>
          </span>
          <span className="regio-card-slogan">Dezvoltăm Oltenia!</span>
        </span>
        <picture>
          <source srcSet="/images/regio/regio-sv-oltenia.webp" type="image/webp" />
          <img
            className="regio-card-logo"
            src="/images/regio/regio-sv-oltenia.png"
            alt="Regio — Programul Regional Sud-Vest Oltenia 2021-2027"
            width="470"
            height="160"
          />
        </picture>
        <picture>
          <source srcSet="/images/regio/eu-cofinantat.webp" type="image/webp" />
          <img
            className="regio-card-eu"
            src="/images/regio/eu-cofinantat.png"
            alt="Cofinanțat de Uniunea Europeană"
            width="746"
            height="160"
          />
        </picture>
      </a>
    </div>
  </section>
);

export default RegioBanners;
